module.exports = __webpack_public_path__ + "img/Inflammation-NPC_GSE200310.ba2d2f5d.png";